import { AREAS } from "@/data/strategy";
import { getType } from "@/data/business";

const TARGET_APP = "F&B .W Management";

const blockToText = (b) => {
  const out = [];
  if (b.heading) out.push(`## ${b.heading}`);
  (b.paragraphs || []).filter(Boolean).forEach((p) => out.push(p));
  (b.bullets || []).forEach((x) => out.push(`- ${x}`));
  (b.rows || []).forEach((r) => out.push(`- ${r.filter((c) => c !== undefined && c !== "").join(": ")}`));
  if (b.markdown) out.push(b.markdown);
  return out.join("\n");
};

export const marketingBlocks = (sub, strategy, sections, focus = "tutto") => {
  const a = sub.answers || {};
  const q = (id) => sections.flatMap((s) => s.questions).find((x) => x.id === id);
  const val = (id) => { const v = a[id]; return Array.isArray(v) ? v.join(", ") : v === undefined || v === "" ? "" : String(v); };
  const row = (id, label) => (val(id) ? [[label || q(id)?.text || id, val(id)]] : []);
  const acts = (area) => [...strategy.primary, ...strategy.secondary, ...strategy.tertiary].filter((x) => x.area === area).map((x) => `${x.title}: ${x.plan}`);
  const marketing = [
    { heading: "Profilo per il marketing", rows: [...row("q5", "Clienti tipo"), ...row("q6", "Da dove arrivano le richieste"), ...row("q2", "Servizio o evento più frequente"), ...row("q19", "Riempimento / calendario"), ...row("q20", "Prezzi rispetto ai concorrenti"), ...row("q22", "Soddisfazione presenza online (1-5)"), ...row("q24", "Strumenti già in uso"), ...row("q7", "Concorrenti citati"), ...row("q13", "Cosa non deve cambiare"), ...row("q15", "Obiettivi a 12 mesi")] },
    { heading: `Azioni marketing suggerite (${AREAS.marketing})`, bullets: acts("marketing").length ? acts("marketing") : ["Nessuna azione marketing emersa dalle risposte"] },
  ];
  const eventi = [
    { heading: "Profilo per l'organizzazione eventi", rows: [...row("q1", q("q1")?.text), ...row("q3", "Spazi e servizi usati davvero"), ...row("q8", "Persone fisse"), ...row("q9", "Come viene coordinato un evento"), ...row("q10", "Dove nascono gli intoppi"), ...row("q23", "Se i titolari mancassero due settimane"), ...row("q11", "Situazione dello chef")] },
    { heading: `Azioni organizzative suggerite (${AREAS.organizzazione})`, bullets: acts("organizzazione").length ? acts("organizzazione") : ["Nessuna azione organizzativa emersa dalle risposte"] },
  ];
  if (focus === "marketing") return marketing;
  if (focus === "eventi") return eventi;
  return [marketing[0], eventi[0], marketing[1], eventi[1]];
};

export const FOCUS = [
  { id: "marketing", label: "Solo marketing", desc: "Target, canali, prezzi, presenza online e azioni commerciali", instr: "impostare il piano marketing: target, canali, posizionamento e calendario di comunicazione" },
  { id: "eventi", label: "Solo organizzazione eventi", desc: "Numeri, spazi, ruoli, intoppi e azioni organizzative", instr: "organizzare gli eventi: ruoli, timeline, scheda evento e controllo dei costi" },
  { id: "tutto", label: "Tutto", desc: "Profili, azioni, report AI e tutte le risposte", instr: "impostare il piano marketing (target, canali, posizionamento, calendario) e l'organizzazione degli eventi (ruoli, timeline, scheda evento, costi)" },
];

export const buildHandoffText = (doc, business, focus = "tutto") => {
  const f = FOCUS.find((x) => x.id === focus) || FOCUS[2];
  const biz = business ? `${business.name || "Attività"} · ${getType(business.type).label}${business.tagline ? ` · ${business.tagline}` : ""}${business.spaces?.length ? `\nSpazi/servizi: ${business.spaces.join(", ")}` : ""}` : "";
  const header = [
    `# BRIEF PER ${TARGET_APP.toUpperCase()}${focus !== "tutto" ? ` · ${f.label.toUpperCase()}` : ""}`,
    `Fonte: questionario del consulente · ${doc.title}${doc.subtitle ? ` · ${doc.subtitle}` : ""}`,
    biz,
    "",
    `Istruzioni: usa i dati qui sotto per ${f.instr}. Dai priorità alle azioni elencate come primarie.`,
  ].filter((l) => l !== undefined).join("\n");
  return `${header}\n\n${doc.blocks.map(blockToText).join("\n\n")}\n`;
};

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
};
